import React, { useState, useEffect, useRef, memo } from 'react';
import { Flex, Text, Image, Box } from 'rebass'
import { useLocation } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import useSWR from 'swr';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useMobileCheckHook } from 'story-media/hooks';
import TextLayer from './TextLayer';
import Modal from 'app/modal/v2/index';
import Preview from './assets/Preview.png';

const { Component } = React;

export class WaterMark extends Component {
    constructor(props) {
        super(props);
        this.id = 'watermark';
    }

    componentDidMount() {
        this.parent = this.watermark.parentNode;
        this.initAttribute(this.watermark);
        this.parentObserver = this.observeParent();
        this.selfObserver = this.observeSelf(this.watermark);
    }

    componentWillUnmount() {
        this.parentObserver.disconnect();
        this.selfObserver.disconnect();
    }

    observeParent = () => {
        const options = {
            childList: true,
        };
        const callback = (mutationsList) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationsList) {
                const removed = mutation.removedNodes[0];
                if (removed && removed.dataset.watermarkid === this.id) {
                    this.selfObserver.disconnect();
                    const { target } = mutation;
                    this.insertClone(target);
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(this.parent, options);

        return observer;
    };

    observeSelf = (node) => {
        const options = {
            attributes: true,
            attributeOldValue: true,
        };
        const callback = (mutationsList, observer) => {
            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationsList) {
                observer.disconnect();

                // let { oldValue, attributeName } = mutation
                // mutation.target.setAttribute(attributeName, oldValue)
                this.initAttribute(mutation.target);
                observer.observe(node, options);
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(node, options);

        return observer;
    };

    /* eslint-disable no-param-reassign, react/destructuring-assignment */
    initAttribute = (target) => {
        target.dataset.watermarkid = this.id;
        target.setAttribute(
            'style',
            `
        position: relative !important;
        transform: none !important;
        width: ${this.props.width}px !important;
        height: ${this.props.height}px !important;
        scale: 1 !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        z-index: 4 !important;
        pointer-events: none;
        background-image: url(${Preview}) !important;
        background-size: 90% 30%;
        background-repeat: no-repeat;
        background-position: 200px 800px;
      `
        );
    };

    insertClone = (target) => {
        const clonedWaterMark = this.watermark.cloneNode(true);
        this.selfObserver = this.observeSelf(clonedWaterMark);
        target.appendChild(clonedWaterMark);
    };

    render() {
        return (
            /* eslint-disable no-return-assign */
            <div id={this.id} data-watermarkid={this.id} ref={(element) => (this.watermark = element)} />
        );
    }
}

export function getAssetUrlsAndAttributes(certificateData, isFromBookCover = false) {
    if (certificateData?.status === 200) {
        const { data, included } = certificateData?.data
        return data.map(item => {
            const imageId = item.relationships?.[isFromBookCover ? 'thumbnail' : 'image'].data.id;
            const thumbnailId = item.relationships?.['thumbnail'].data.id;

            const image = included.find(i => i.id === imageId);
            const thumbnailDetails = included.find(i => i.id === thumbnailId);

            const imageVersions = image?.attributes?.['image-versions']
            const thumbnailDetailsVersions = thumbnailDetails?.attributes?.['image-versions']

            return {
                assetUrl: image ? thumbnailDetailsVersions[1]?.url : null,
                mainImage: image ? imageVersions[imageVersions?.length - 1]?.url : null,
                attributes: item.attributes,
                id: item.id,
            };
        });
    }

    return []
}

export const InlineEditing = React.forwardRef(({ zoom, setZoom, posterSectionWidth, parentHeight, certificateDetails, name_of_recipient, name_of_giver }, ref) => {
    const isFromMobile = useMobileCheckHook()
    const reactpinchzoomRef = useRef()

    useEffect(() => {
        if (reactpinchzoomRef.current) {
            const { zoomToElement } = reactpinchzoomRef.current;
            zoomToElement('templateContainer');
        }
    }, [reactpinchzoomRef?.current]);

    useEffect(() => {
        if (posterSectionWidth && certificateDetails?.attributes?.width) {
            const widthZoom = (posterSectionWidth / certificateDetails?.attributes.width) * 100;
            const heightZoom = (parentHeight / certificateDetails?.attributes.height) * 100;

            const zoomPercentage = Math.min(widthZoom, heightZoom);
            setZoom(zoomPercentage);
        }
    }, [
        isFromMobile,
        posterSectionWidth,
        parentHeight,
        certificateDetails?.attributes?.width,
        certificateDetails?.attributes?.height,
    ]);

    return <TransformWrapper
        ref={reactpinchzoomRef}
        centerZoomedOut
        centerOnInit
        limitToBounds
    // disabled={!isTouchDevice()}
    >
        <TransformComponent contentStyle={{ width: '100%' }} wrapperStyle={{ width: '100%' }}>
            <Flex
                flexDirection="column"
                justifyContent="center"
                pt={4}
                ref={ref}
                sx={{
                    zoom: `${zoom}% `,
                    MozTransform: `scale(${zoom / 100})`,
                    MozTransformOrigin: '10% 0',
                    position: 'relative',
                    boxShadow: '0px 7px 36px 5px rgba(0, 0, 0, 0.25)',
                    width: `${certificateDetails?.attributes.width}px`,
                    height: `${certificateDetails?.attributes?.height}px`,
                    left: 0,
                    right: 0,
                    m: 'auto',
                    touchAction: 'pan-x pan-y pinch-zoom',
                }}
                id="templateContainer"
            >
                {certificateDetails?.attributes?.height && <Box mb={`-${certificateDetails?.attributes?.height}px`}>
                    <WaterMark height={certificateDetails?.attributes?.height} width="100%" />
                </Box>}
                <Image src={certificateDetails?.mainImage} sx={{ zIndex: 1 }} />
                <TextLayer {...certificateDetails?.attributes}
                    zoom={zoom}
                    text={"To " + name_of_recipient}
                    // xpos={certificateDetails?.attributes?.['x-name-of-recipient']}
                    ypos={certificateDetails?.attributes?.['y-name-of-recipient']}
                    fontAlignment={certificateDetails?.attributes?.['alignment-name-of-recipient']}
                    fontFamily="Amatic SC"
                    fontWeight={700}
                    fontSize={`${10 * zoom}px`}
                    color="#000"
                />
                <TextLayer {...certificateDetails?.attributes}
                    zoom={zoom}
                    text={"From " + name_of_giver}
                    // xpos={certificateDetails?.attributes?.['x-name-of-giver']}
                    ypos={certificateDetails?.attributes?.['y-name-of-giver']}
                    fontAlignment={certificateDetails?.attributes?.['alignment-name-of-giver']}
                    fontFamily="Quicksand"
                    fontWeight={300}
                    fontSize={`${7 * zoom}px`}
                    color="#373737"
                />
            </Flex>
        </TransformComponent>
    </TransformWrapper>
})

const GiftCertificateStyle = React.forwardRef(({ name_of_recipient, setNameOfRecipient, name_of_giver, setNameOfGiver, gift_certificate_style_id, isFromGetStarted = false, setGiftCertificateStyleId, isFromBookCover, isFromPreview, attributes }, ref) => {
    const { data } = useSWR(`/v3/commerce/gift_certificate_styles`);
    const { pathname } = useLocation();

    const certificatesData = getAssetUrlsAndAttributes(data, isFromBookCover);
    const [selectedImage, setSelectedImage] = useState(null);
    const [zoom, setZoom] = useState(null);
    const [posterSectionWidth, setPosterSectionWidth] = useState(0);
    const [parentHeight, setParentHeight] = useState(null);
    const [openSelectedImage, setOpenSelectedImage] = useState(null);
    const { width } = useWindowSize();
    const isFromGift = pathname.includes('/gift')

    useEffect(() => {
        if (certificatesData.length > 0) {
            if (gift_certificate_style_id)
                setSelectedImage(certificatesData.find(certificate => certificate?.id === gift_certificate_style_id))
            // else {
            //     if (setGiftCertificateStyleId)
            //         setGiftCertificateStyleId(certificatesData[0]?.id)
            // }
        }
    }, [gift_certificate_style_id, certificatesData?.length])

    const display = width < 600 || isFromGift ? 'grid !important' : ['grid', 'grid', 'flex']
    return <Flex flexDirection="column" maxWidth={700} mb="30px" >
        {!isFromGetStarted && !isFromPreview && <Text mb={4} as="span" fontFamily="Poppins" fontSize={15} fontWeight={500} letterSpacing="-0.3px" >
            {isFromBookCover ? 'Choose a style for your book cover' : <>
                <span>Choose a style for your gift certificate <span style={{ color: 'red' }}>*</span ></span>
            </>}
        </Text>}
        <Flex flexDirection={['column', 'column', isFromGift ? 'column' : 'row']}>
            {!isFromGetStarted && !isFromPreview && <Flex
                flexDirection="column"
                display={display}
                sx={{
                    gridTemplateColumns: width < 600 ? `repeat(auto-fit, minmax(80px, 1fr))` : `repeat(auto-fit, minmax(100px, 1fr))`,
                    gridGap: '4px'
                }}
                mr={3}>
                {openSelectedImage && <Modal
                    onClose={() => setOpenSelectedImage(null)}
                    maxWidth={600}
                    closeButton
                    title={""} >
                    <Image src={openSelectedImage} />
                </Modal>}
                {certificatesData.map((certificate) =>
                    <Box
                        width={width < 600 ? 80 : 100}
                        onClick={() => {
                            setGiftCertificateStyleId(certificate?.id)
                            if (isFromGift)
                                setOpenSelectedImage(certificate?.assetUrl)
                            // setSelectedImage(certificate)
                            window.scrollTo({
                                top: document.body.scrollHeight - 250,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }}
                        p="4px"
                        mb={1}
                        sx={{
                            borderRadius: '8px',
                            border: `2px solid ${selectedImage?.id === certificate?.id ? '#763099' : 'rgba(0, 0, 0, 0.20)'}`,
                            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
                            cursor: 'pointer'
                        }}>
                        <Image src={certificate?.assetUrl} />
                    </Box>
                )}
            </Flex>}
            {selectedImage && !isFromGift && (isFromBookCover ?
                <Flex
                    width="100%"
                    height={['unset', 'unset', 720]}
                    overflow="auto"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        position: 'relative',
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.05)',
                        background: '#FAFAFA'
                    }}
                >
                    <Flex
                        width="100%"
                        maxWidth={400}
                        maxHeight={600}
                        minHeight={['unset', 500]}
                        my={2}
                        mx="auto"
                        sx={{
                            borderRadius: '5px',
                            border: '1px solid rgba(0, 0, 0, 0.10)',
                            background: '#FFF',
                            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)'
                        }}>
                        <Flex width="20px" sx={{
                            borderRadius: '8px 0px 0px 8px',
                            background: 'linear-gradient(270deg, #FAFAFA 0%, #FFF 100%)'
                        }} />
                        <Flex width="10px" sx={{
                            borderLeft: '1px solid rgba(0, 0, 0, 0.03)',
                            background: 'linear-gradient(270deg, #FFF 0%, #F6F6F6 100%)'
                        }} />
                        <Flex
                            width={"100%"}
                            flexDirection="column"
                            sx={{
                                borderRight: '1px solid rgba(0, 0, 0, 0.01)',
                                background: 'linear-gradient(270deg, #FCFCFC 0%, #FFF 100%)'
                            }}
                            justifyContent="center"
                            alignItems="center"
                            padding="48px"
                        >
                            <Image src={selectedImage?.mainImage} maxWidth="240px" sx={{ zIndex: 1 }} mb={2} />

                            <TextLayer
                                isFromBookCover={isFromBookCover}
                                zoom={1}
                                value={name_of_recipient}
                                xpos={selectedImage?.attributes?.['x-name-of-recipient']}
                                ypos={selectedImage?.attributes?.['y-name-of-recipient']}
                                fontAlignment={selectedImage?.attributes?.['alignment-name-of-recipient']}
                                fontFamily="Amatic SC"
                                fontWeight={700}
                                fontSize={`${18}px`}
                                color="#000"
                            />
                        </Flex>
                    </Flex>
                </Flex>
                : <Flex
                    width="100%"
                    height={['unset', 'unset', 720]}
                    overflow="auto"
                    justifyContent="center"
                    alignItem="center"
                    sx={{
                        position: 'relative', borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.05)',
                        background: '#FAFAFA'
                    }}
                    ref={(el) => {
                        if (!el) return;
                        setPosterSectionWidth(el.getBoundingClientRect().width);
                        setParentHeight(el.getBoundingClientRect().height);
                    }}
                >
                    <InlineEditing
                        posterSectionWidth={posterSectionWidth}
                        parentHeight={parentHeight}
                        certificateDetails={selectedImage}
                        zoom={zoom}
                        setZoom={setZoom}
                        name_of_recipient={name_of_recipient}
                        name_of_giver={name_of_giver}
                        ref={ref}
                    />
                </Flex>)}
        </Flex>

    </Flex >
})

export default memo(GiftCertificateStyle);